// src/supportData.js

const data = [
    {
        title: 'Product Creation',
        description: 'Manage the creation of new products and their details.',
        link: '/creation',
        slug: 'productcreation',
        steps: [
            {
                image: '/softwareimg/Productcreation/creation1.png',
                message: 'Click Next to begin the Product Creation process.'
            },
            {
                image: '/softwareimg/Productcreation/creation2.png',
                message: 'Click Next to proceed with Product Details.'
            },
            {
                image: '/softwareimg/Productcreation/creation3.png',
                message: 'Click Next to save the Product Details.'
            },
            {
                image: '/softwareimg/Productcreation/creation4.png',
                message: 'Product has been successfully created!'
            }
        ]
    },
    {
        title: 'Account Creation',
        description: 'Create new user accounts and manage access.',
        link: '/creation',
        slug: 'accountcreation',
        steps: [
            {
                image: '/softwareimg/Accountcreation/creation1.png',
                message: 'Click Next to begin the Account Creation process.'
            },
            {
                image: '/softwareimg/Accountcreation/creation2.png',
                message: 'Click Next to proceed with Account Details.'
            },
            {
                image: '/softwareimg/Accountcreation/creation3.png',
                message: 'Click Next to save the Account Details.'
            },
            {
                image: '/softwareimg/Accountcreation/creation4.png',
                message: 'Account has been successfully created!'
            }
        ]
    },
    {
        title: 'Sales Bills',
        description: 'Generate and manage sales bills for customers.',
        link: '/creation',
        slug: 'salesbills',
        steps: [
            {
                image: '/softwareimg/Salesentry/creation1.png',
                message: 'Click Next to start creating a new Sales Bill.'
            },
            {
                image: '/softwareimg/Salesentry/creation2.png',
                message: 'Click Next to proceed with Main Details.'
            },
            {
                image: '/softwareimg/Salesentry/creation3.png',
                message: 'Click Next to proceed with Product Details.'
            },
            {
                image: '/softwareimg/Salesentry/creation4.png',
                message: 'Click Next to Add the Products.'
            },
            {
                image: '/softwareimg/Salesentry/creation5.png',
                message: 'Click Next to add More Products.'
            },
            {
                image: '/softwareimg/Salesentry/creation6.png',
                message: 'Click Next to proceed with Discounts.'
            },
            {
                image: '/softwareimg/Salesentry/creation7.png',
                message: 'Click Next to apply the Discounts.'
            },
            {
                image: '/softwareimg/Salesentry/creation8.png',
                message: 'Click Next to apply different types of Discounts.'
            },
            {
                image: '/softwareimg/Salesentry/creation9.png',
                message: 'Click Next to save the Sales Bill.'
            },
            {
                image: '/softwareimg/Salesentry/creation10.png',
                message: 'Sales Bill Saved Successfully.'
            },
        ]
    },
    {
        title: 'Purchase Bills',
        description: 'Track and manage purchase bills for your business.',
        link: '/creation',
        slug: 'purchasebills',
        steps: [
            {
                image: '/softwareimg/Purchaseentry/creation1.png',
                message: 'Click Next to start creating a new Purchase Bill.'
            },
            {
                image: '/softwareimg/Purchaseentry/creation2.png',
                message: 'Click Next to proceed with Main Details.'
            },
            {
                image: '/softwareimg/Purchaseentry/creation3.png',
                message: 'Click Next to proceed with Product Details.'
            },
            {
                image: '/softwareimg/Purchaseentry/creation4.png',
                message: 'Click Next to Add the Products.'
            },
            {
                image: '/softwareimg/Purchaseentry/creation5.png',
                message: 'Click Next to add More Products.'
            },
            {
                image: '/softwareimg/Purchaseentry/creation6.png',
                message: 'Click Next to proceed with Discounts.'
            },
            {
                image: '/softwareimg/Purchaseentry/creation7.png',
                message: 'Click Next to apply the Discounts.'
            },
            {
                image: '/softwareimg/Purchaseentry/creation8.png',
                message: 'Click Next to apply different types of Discounts.'
            },
            {
                image: '/softwareimg/Purchaseentry/creation9.png',
                message: 'Click Next to save the Purchase Bill.'
            },
            {
                image: '/softwareimg/Purchaseentry/creation10.png',
                message: 'Purchase Bill Saved Successfully.'
            },
        ]
    },
];

export default data;